import { PaymentSource, Transaction } from 'models/Transaction'
import { RootState } from 'redux/store'
import { Frequency } from '@classy/campaign-page-blocks'
import { PurchaseCookieDto } from 'models/Purchase'

export const getPurchaseCookieObjFromTransaction = (
  transaction: Transaction,
  store: RootState,
): PurchaseCookieDto => ({
  id: String(transaction.id),
  comment: transaction.comment,
  company_match: {
    id: store.order.doubleTheDonation.value?.companyId ?? undefined,
    name: store.order.doubleTheDonation.value?.companyName || undefined,
  },
  company_name: transaction.company_name ?? undefined,
  created_at: transaction.created_at,
  currency_code: transaction.currency_code,
  designation_id: String(transaction.designation_id),
  donation_gross_amount: transaction.donation_gross_amount,
  billing_country: transaction.billing_country,
  billing_first_name: transaction.billing_first_name,
  billing_last_name: transaction.billing_last_name,
  billing_postal_code: transaction.billing_postal_code,
  frequency: transaction.frequency as Frequency,
  has_dedication: store.order.dedication.hasDedication,
  is_anonymous: transaction.is_anonymous,
  is_donor_covered_fee: transaction.is_donor_covered_fee,
  member_email_address: transaction.member_email_address,
  member_id: String(transaction.member_id),
  normalized_fees_covered: Number(transaction.adjustment_amount),
  overhead_net_amount: transaction.overhead_net_amount,
  payment_source: transaction.payment_source as PaymentSource,
  raw_adjustment_amount: transaction.raw_adjustment_amount,
  raw_currency_code: transaction.raw_currency_code,
  raw_donation_gross_amount: transaction.raw_donation_gross_amount,
  raw_initial_gross_amount: transaction.raw_initial_gross_amount,
  raw_overhead_net_amount: transaction.raw_overhead_net_amount,
  raw_total_gross_amount: String(transaction.raw_total_gross_amount),
  supporter_id: transaction.supporter_id,
  total_gross_amount: transaction.total_gross_amount,
})
